import React, { useContext, useMemo } from "react";
import { Stack, Typography, Button } from "@mui/material";

import logo from "../../images/icon-white.png";
import { colors } from "../../const";
import { useNavigate } from "react-router-dom";
import { usePredefinedQueryParams } from "../../hooks";
import { RoutesPath } from "../../routing/routes";
import { mainContext } from "../../context";

const styles = {
  image: {
    width: "80px",
    height: "80px",
  },
  subtitle: {
    color: colors.halfTransparentBlue,
  },
  label: {
    color: colors.activeGreen,
    marginBottom: "30px",
    textAlign: "center",
    fontWeight: "600",
  },
  startButton: {
    backgroundColor: colors.activeGreen,
    borderRadius: "20px",
    width: "150px",
    "&:hover": {
      backgroundColor: colors.activeGreen,
      opacity: 0.8,
    },
    "&.Mui-disabled": {
      color: colors.halfTransparentBlue,
      backgroundColor: colors.lightBlue,
      cursor: "not-allowed",
    },
  },
};

export const WelcomeMobilePage: React.FC = () => {
  const navigate = useNavigate();

  const { setHasShowedWelcomeMobileScreen } = useContext(mainContext);
  const { predefinedParams, rawStringParams } = usePredefinedQueryParams();

  const homeUrl = useMemo(
    () => `${RoutesPath.HOME}?${rawStringParams}`,
    [rawStringParams],
  );

  const handleNavigateToHomeScreen = () => {
    navigate(homeUrl);
    setHasShowedWelcomeMobileScreen(true);
  };

  return (
    <Stack alignItems="center" rowGap={4}>
      <img src={logo} style={styles.image} alt="..." />
      <Stack m={2}>
        <Typography typography="h5" fontWeight="600" textAlign="center" mb={2}>
          Welcome to the {predefinedParams?.company.name} issue reporting tool.
        </Typography>
        <Typography typography="h6" textAlign="center" sx={styles.subtitle}>
          Brought to you by Cleverly.
        </Typography>
      </Stack>
      <Typography typography="h5" m={2} sx={styles.label}>
        Here, you can report an issue quickly and easily.
      </Typography>

      <Button
        disabled={!predefinedParams}
        onClick={handleNavigateToHomeScreen}
        sx={styles.startButton}
        size="large"
        variant="contained"
      >
        Start
      </Button>
    </Stack>
  );
};
